export enum InputType{
    text = "text",
    select = "select",
    number = "number",
    email = "email"
}